import { AuthRepository } from "../../domain/repositories/AuthRepository";
import { AuthDataSource } from "../datasource/AuthDataSource";
import { AppConstants } from "../../../../core/constants/constants";
import { AuthLoginResult } from "../../domain/entities/AuthLoginResult";

export class AuthRepositoryImpl implements AuthRepository {
  constructor(private dataSource: AuthDataSource) {}
  loginGmail(token: string): Promise<AuthLoginResult> {
    return AppConstants.getRightOrLeftSide<AuthLoginResult>(
      this.dataSource.loginGmail(token),
    );
  }
  logout(): Promise<void> {
    return AppConstants.getRightOrLeftSide<void>(this.dataSource.logout());
  }
  sendOtp(email: string, type: string): Promise<void> {
    return AppConstants.getRightOrLeftSide<void>(
      this.dataSource.sendOtp(email, type),
    );
  }
  renew(): Promise<void> {
    return AppConstants.getRightOrLeftSide<void>(this.dataSource.renew());
  }
  setPassword(password: string): Promise<void> {
    return AppConstants.getRightOrLeftSide<void>(
      this.dataSource.setPassword(password),
    );
  }
  login(
    otp: string,
    type: string,
    emailOrPhone: string,
    isLogin?: boolean,
    password?: string,
  ): Promise<AuthLoginResult> {
    return AppConstants.getRightOrLeftSide<AuthLoginResult>(
      this.dataSource.login(otp, type, emailOrPhone, isLogin!, password),
    );
  }
  removeAccount(otp: string): Promise<void> {
    return this.dataSource.removeAccount(otp);
  }
  requestRemoveAccount(): Promise<void> {
    return this.dataSource.requestRemoveAccount();
  }
}
